import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const getCountryList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.COUNTRY_LIST_API);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
